/**
 * LanguageSelector.jsx - Language switcher for i18n
 *
 * Compact dropdown for selecting UI language.
 * Supports: English, Japanese, Simplified Chinese
 */

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const LANGUAGES = [
  { code: 'en', label: 'English', flag: 'EN' },
  { code: 'ja', label: '日本語', flag: 'JA' },
  { code: 'zh-CN', label: '中文', flag: 'CN' },
];

export default function LanguageSelector({ className = '', style = {} }) {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const currentLang = LANGUAGES.find(l => l.code === i18n.language) || LANGUAGES[0];

  const handleSelect = (langCode) => {
    i18n.changeLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <div className={`relative ${className}`} style={style}>
      {/* Current language button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-1.5 text-xs tracking-wider rounded border transition-colors"
        style={{
          borderColor: '#60ffd040',
          color: '#60ffd0',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        }}
      >
        <span className="font-bold">{currentLang.flag}</span>
        <span className="hidden sm:inline">{currentLang.label}</span>
        <span className="text-gray-500">▼</span>
      </button>

      {/* Dropdown */}
      {isOpen && (
        <>
          {/* Backdrop to close on click outside */}
          <div
            className="fixed inset-0 z-40"
            onClick={() => setIsOpen(false)}
          />

          <div
            className="absolute top-full mt-1 right-0 z-50 min-w-[120px] rounded border overflow-hidden"
            style={{
              borderColor: '#60ffd040',
              backgroundColor: 'rgba(0, 0, 0, 0.9)',
            }}
          >
            {LANGUAGES.map((lang) => (
              <button
                key={lang.code}
                onClick={() => handleSelect(lang.code)}
                className="w-full flex items-center gap-2 px-3 py-2 text-xs text-left transition-colors hover:bg-white/10"
                style={{
                  color: lang.code === i18n.language ? '#60ffd0' : '#9ca3af',
                }}
              >
                <span className="font-bold w-6">{lang.flag}</span>
                <span>{lang.label}</span>
                {lang.code === i18n.language && (
                  <span className="ml-auto" style={{ color: '#60ffd0' }}>✓</span>
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
